"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationListFilters = exports.defaultQuickFilters = exports.testIds = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const lodash_es_1 = require("lodash-es");
const react_1 = require("react");
const useNotificationListState_1 = require("../hooks/useNotificationListState");
const translations_1 = require("../types/translations");
const NotificationListFiltersSidebar_1 = require("./NotificationListFiltersSidebar");
const NotificationListSelectedFilters_1 = require("./NotificationListSelectedFilters");
exports.testIds = {
    quickFilterCheckbox: 'notification_list-filters-quick_filter',
};
const trackingIds = {
    quickFilter: 'notification_list-filters-quick_filter',
    moreFilters: 'notification_list-filters-more_filters_button',
};
exports.defaultQuickFilters = [notification_center_models_1.NotificationType.Deviation, notification_center_models_1.NotificationType.DeviationRisk];
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    filterButton: {
        height: 30,
        width: 95,
    },
    filterIcon: {
        marginRight: theme.spacing(1.3),
    },
    quickFilter: {
        padding: theme.spacing(1, 1, 1, 2.5),
    },
}));
const NotificationListFilters = () => {
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const { typeFilter, setTypeFilter } = (0, useNotificationListState_1.useNotificationListState)();
    const [sideBarVisibility, setSideBarVisibility] = (0, react_1.useState)(false);
    const toggleSidebarVisibility = () => {
        setSideBarVisibility(!sideBarVisibility);
    };
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { flex: 1, display: "flex", flexDirection: "column", children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Grid, { container: true, className: classes.quickFilter, alignItems: "center", children: [exports.defaultQuickFilters.map((quickFilter) => ((0, jsx_runtime_1.jsx)(silhouette_core_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Checkbox, { color: "primary", name: quickFilter, checked: (0, lodash_es_1.includes)(typeFilter, quickFilter), "data-tracking-id": `${trackingIds.quickFilter}-${quickFilter}`, inputProps: {
                                        'data-testid': `${exports.testIds.quickFilterCheckbox}-${quickFilter}`,
                                    }, onChange: () => {
                                        const filters = (0, lodash_es_1.includes)(typeFilter, quickFilter)
                                            ? typeFilter.filter((filter) => filter !== quickFilter)
                                            : [...typeFilter, quickFilter];
                                        setTypeFilter(filters);
                                    } }) }), label: translate((0, translations_1.getNotificationFilterTranslation)(quickFilter)) }, quickFilter))), (0, jsx_runtime_1.jsx)(silhouette_core_1.Grid, { children: (0, jsx_runtime_1.jsxs)(silhouette_core_1.Button, { onClick: toggleSidebarVisibility, className: classes.filterButton, variant: "outlined", color: "primary", "data-tracking-id": trackingIds.moreFilters, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.FilterListIcon, { className: classes.filterIcon }), translate(translations_1.notificationListFilterTranslations.filterButton)] }) })] }) }), (0, jsx_runtime_1.jsx)(NotificationListSelectedFilters_1.NotificationListSelectedFilters, {}), (0, jsx_runtime_1.jsx)(silhouette_core_1.Divider, {}), (0, jsx_runtime_1.jsx)(NotificationListFiltersSidebar_1.NotificationListFiltersSidebar, { open: sideBarVisibility, onClose: () => setSideBarVisibility(false) })] }));
};
exports.NotificationListFilters = NotificationListFilters;
//# sourceMappingURL=NotificationListFilters.js.map